import { useContext } from 'react';
import { Link } from 'react-router-dom';
import { UserContext } from '../../Routes/Routes1';
import { Navbar, SideNavbar } from '../components';
import './header.css'


export default function Header(){
    const {state,dispatch}=useContext(UserContext)
    function logOut(){
        dispatch({type:"USER",payload:false})
        localStorage.removeItem("sangeetUser")
    }

    const RenderUserLogIn=()=>{
        const USER_STORAGE=localStorage.getItem("sangeetUser")
        if(state){
            return(
                <>
                    <div className="col-sm-2 col-3">
                        <Link to="/profile" style={{textDecoration:'none'}}>{JSON.parse(USER_STORAGE).name}</Link>
                    </div>
                    <div className="col-sm-2 col-3">
                        <button className="btn btn-light btn-sm" onClick={logOut}>Log Out</button>
                    </div>
                </>
            )
        }
        else{
            return(
                <div className="col-sm-4 col-6">
                    <Link to="/login"><button className="btn btn-light btn-sm ">Log In</button></Link>
                    <Link to="/signup"><button className="btn btn-light btn-sm" id="signUp">Sign Up</button></Link>
                </div>
            )
        }
    }

    return(
        <>
            <div className="row p-1 headLine fixed-top">
                <div className="col-sm-1 col-1"><SideNavbar/></div>
                <div className="col-sm-7 col-5">
                    <Link to='/' style={{textDecoration:'none'}}><h3 className="head-text">𝄞 SANGEET</h3></Link>
                </div>
                
                <RenderUserLogIn/>
                <Navbar/>
            </div>
        </>
    );
}